import React from "react"
import "./PasswordField.css"
import { ViewPasswordButton, HidePasswordButton } from "../../Icons"

class PasswordField extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      shown: false
    }
  }
  togglePasswordVisibility = () => {
    this.setState(prevState => ({
      shown: !prevState.shown
    }))
  }
  render() {
    const {
      field,
      form: { touched, errors },
      ...props
    } = this.props
    let status = "default"
    if (touched[field.name] && errors[field.name]) {
      status = "has-error"
    } else if (touched[field.name] && !errors[field.name]) {
      status = "is-fixed"
    }
    return (
      <div className={`TextField PasswordField ${status}`}>
        <span className="show-pass-btn" onClick={this.togglePasswordVisibility}>
          {this.state.shown ? <ViewPasswordButton /> : <HidePasswordButton />}
        </span>
        <input
          {...field}
          {...props}
          type={this.state.shown ? "text" : "password"}
        />
        {touched[field.name] &&
          errors[field.name] && (
            <div className="error-message">{errors[field.name]}</div>
          )}
      </div>
    )
  }
}

export default PasswordField
